import { ICustomLookupColumn, ICustomLookupOptions } from '../constants';
import { DEFAULT_SEARCH_SCREEN_DIALOG_STYLE } from './customLookupDefaults.contants';
export const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
    {
        dataField: 'CustomerId',
        caption: 'Customer',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: true,
        hideInV3: true
    },
    {
        dataField: 'CustomerAccountNumber',
        caption: 'Customer',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: true,
        hideInV2: true
    },
    {
        dataField: 'Name',
        caption: 'Name',
        allowResizing: true,
        minWidth: 300,
        width: 300,
        fixed: false
    },
    {
        dataField: 'Abbreviation',
        caption: 'Abbreviation',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: false
    },
    {
        dataField: 'City',
        caption: 'City',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: false
    },
    {
        dataField: 'State',
        caption: 'State',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: false
    },
    {
        dataField: 'SalesEntity',
        caption: '',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false,
        hideInV3: true
    },
];

export const customerLookupConstants: ICustomLookupOptions = {
    columns: LOOKUP_COLUMNS,
    dialogStyle: DEFAULT_SEARCH_SCREEN_DIALOG_STYLE,
    hideColumnHeaders: false,
    disableGridColumnLines: false,
    dataPrefix: 'Details',
    tabbedLookup: {
        isTabbedLookup: true,
    }
};
